module.exports = __webpack_public_path__ + "static/media/wheel-center-timeline-einstein.424cc4d1.png";